export default {"src":"/_next/static/media/submission_loading.1e8fc797.svg","height":217,"width":217,"blurWidth":0,"blurHeight":0};